import React from "react";
import { useNavigate } from "react-router-dom";

import { Routes } from "../../navigation";
import RegistrationForm from "./components/RegistrationForm/RegistrationForm";
import { RegistrationPageCmp } from "./types";

const RegistrationPage: RegistrationPageCmp = () => {
  const [redirect, setRedirect] = React.useState(false);

  let navigate = useNavigate();

  const redirectToLoginPage = () => {
    setRedirect(true);
  };

  if (redirect) {
    navigate(Routes.LoginPage);
  }

  return <RegistrationForm afterRegistration={redirectToLoginPage} />;
};

RegistrationPage.route = Routes.RegistrationPage;

export default RegistrationPage;
